import { render, staticRenderFns } from "./AddProductToCartInstallmentsInformation.vue?vue&type=template&id=c89fb964"
import script from "./AddProductToCartInstallmentsInformation.vue?vue&type=script&lang=js"
export * from "./AddProductToCartInstallmentsInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports